import React, { Component } from 'react';

class AccountsReceivableBody extends Component {

    render() {
        const {
            paymentSummary = [],   // [{ key:'transfer', label:'Transferencia', account:'1102-01 Bancos', amount:1000 }]
            CURRENCY = '$',
            formatNumber,
            action = 1
        } = this.props;

        return (
            <div className="tab-content" style={{ paddingTop: 5, textAlign: 'left' }}>
                <div
                    className="w-100 table-scroll tab-pane active"
                    role="tabpanel"
                    style={{ maxHeight: 2000, paddingTop: 5 }}
                >
                    <table
                        className="display"
                        style={{ width: '100%', marginBottom: 40 }}
                    >
                        <thead className="table-header-yellow">
                            <tr>
                                <td className="sticky-columns">
                                    Método de pago
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    Cuenta de mayor
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    Descripción
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    Monto
                                </td>
                                <td
                                    className="sticky-header sticky-columns"
                                    style={{ backgroundColor: '#d2ab24' }}
                                />
                            </tr>
                        </thead>

                        <tbody>
                            {paymentSummary.map((item, index) => (
                                <tr key={index}>

                                    {/* Método */}
                                    <td className="sticky-columns font-weight-bold">
                                        {item.label}
                                    </td>

                                    {/* Cuenta mayor */}
                                    <td style={{ textAlign: 'center', fontWeight: 600 }}>
                                        {item.account}
                                    </td>

                                    {/* Descripción */}
                                    <td style={{ textAlign: 'center' }}>
                                        Cobro por {item.label.toLowerCase()}
                                    </td>

                                    {/* Monto */}
                                    <td style={{ textAlign: 'right' }}>
                                        {CURRENCY + (formatNumber
                                            ? formatNumber.new(item.amount)
                                            : item.amount)}
                                    </td>

                                    {/* Eliminar */}
                                    <td
                                        className="sticky-columns"
                                        style={{ backgroundColor: '#FFF', textAlign: 'center' }}
                                    >
                                        {action === 1 && (
                                            <button
                                                type="button"
                                                className="btn"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    padding: 5,
                                                    color: '#c42222'
                                                }}
                                                onClick={() => this.props.onDeleteLine(index)}
                                            >
                                                <i className="fas fa-trash-alt" />
                                            </button>
                                        )}
                                    </td>

                                </tr>
                            ))}

                            {/* Agregar línea */}
                            <tr>
                                <td
                                    className="sticky-columns"
                                    style={{ backgroundColor: '#FFF', textAlign: 'center' }}
                                >
                                    {action === 1 && (
                                        <button
                                            type="button"
                                            className="btn"
                                            style={{
                                                backgroundColor: 'transparent',
                                                padding: 5,
                                                color: 'green'
                                            }}
                                            onClick={this.props.onAddLine}
                                        >
                                            <i className="fa fa-plus-circle" />
                                        </button>
                                    )}
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default AccountsReceivableBody;
